var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "set6/icn_copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-660.000000, -677.000000)",
    fill: "#015DD2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(660.000000, 677.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.44327731,14.935761 L3.44327731,4.99365079 L1.91806723,4.99365079 C0.924369748,4.99365079 0.115546218,5.78450047 0.115546218,6.75611578 L0.115546218,19.8164332 C0.115546218,20.7880486 0.924369748,21.5788982 1.91806723,21.5788982 L12.039916,21.5788982 C13.0336134,21.5788982 13.842437,20.7880486 13.842437,19.8164332 L13.842437,18.3251167 L6.90966387,18.3251167 C4.99159664,18.3251167 3.44327731,16.8112045 3.44327731,14.935761 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.302521,3.75088702 L15.0903361,0.632679739 C14.7436975,0.293744164 14.3046218,0.112978525 13.8193277,0.112978525 L6.90966387,0.112978525 C5.91596639,0.112978525 5.10714286,0.903828198 5.10714286,1.87544351 L5.10714286,14.935761 C5.10714286,15.9073763 5.91596639,16.698226 6.90966387,16.698226 L17.0315126,16.698226 C18.0252101,16.698226 18.8340336,15.9073763 18.8340336,14.935761 L18.8340336,5.0162465 C18.8340336,4.54173669 18.6491597,4.0898226 18.302521,3.75088702 Z M8.94327731,4.92586368 L13.1029412,4.92586368 C13.5651261,4.92586368 13.9348739,5.28739496 13.9348739,5.73930906 C13.9348739,6.19122316 13.5651261,6.55275444 13.1029412,6.55275444 L8.94327731,6.55275444 C8.48109244,6.55275444 8.11134454,6.19122316 8.11134454,5.73930906 C8.11134454,5.28739496 8.48109244,4.92586368 8.94327731,4.92586368 Z M14.9747899,13.5800187 L8.94327731,13.5800187 C8.48109244,13.5800187 8.11134454,13.2184874 8.11134454,12.7665733 C8.11134454,12.3146592 8.48109244,11.9531279 8.94327731,11.9531279 L14.9747899,11.9531279 C15.4369748,11.9531279 15.8067227,12.3146592 15.8067227,12.7665733 C15.8067227,13.2184874 15.4369748,13.5800187 14.9747899,13.5800187 Z M14.9747899,10.0550887 L8.94327731,10.0550887 C8.48109244,10.0550887 8.11134454,9.69355742 8.11134454,9.24164332 C8.11134454,8.78972923 8.48109244,8.42819795 8.94327731,8.42819795 L14.9747899,8.42819795 C15.4369748,8.42819795 15.8067227,8.78972923 15.8067227,9.24164332 C15.8067227,9.69355742 15.4369748,10.0550887 14.9747899,10.0550887 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.439abffa.svg";
export { ForwardRef as ReactComponent };